import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '@express-labs/raven-tools';
import s from './HoverableSlideOutModal.module.scss';

function HoverableSlideOutModal(props) {
  const {
    component,
    containerClassName,
    fitContent,
    hideOverlay,
    modalClassName,
    onMouseEnter,
    onMouseLeave,
    overlayClassName,
    overlayProps,
    showModal,
    target,
    topPosition,
  } = props;
  return (
    <>
      <div
        className={cn(s.modal, containerClassName)}
        aria-label="modal"
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <div className={s.before} style={{ top: `calc(${topPosition} - 66px)` }} />
        {target}
        {showModal && (
          <div
            style={{ top: topPosition, height: `calc(100% - ${topPosition})` }}
            className={cn(s.modalContent, modalClassName, fitContent && s.modalContentFit)}
            aria-label="modal-content"
          >
            {component}
          </div>
        )}
      </div>
      {hideOverlay || <div className={cn(s.overlay, overlayClassName)} {...overlayProps} />}
    </>
  );
}

HoverableSlideOutModal.propTypes = {
  component: PropTypes.node,
  containerClassName: PropTypes.string,
  fitContent: PropTypes.bool,
  hideOverlay: PropTypes.bool,
  modalClassName: PropTypes.string,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  overlayClassName: PropTypes.string,
  overlayProps: PropTypes.shape({}),
  showModal: PropTypes.bool,
  target: PropTypes.node.isRequired,
  topPosition: PropTypes.string,
};

HoverableSlideOutModal.defaultProps = {
  component: null,
  containerClassName: '',
  fitContent: false,
  hideOverlay: false,
  modalClassName: '',
  onMouseEnter: null,
  onMouseLeave: null,
  overlayClassName: '',
  overlayProps: {},
  showModal: true,
  topPosition: '10.3rem',
};

export default HoverableSlideOutModal;
